import * as React from 'react';
import { createHashRouter, RouterProvider } from "react-router-dom";

import { ToastContainer } from '@independent-software/typeui/controls/Toast';

import { ROUTES } from './config/Routes';
import { Screen } from './environment/Screen';
import { AccessDenied } from './components/Auth/AccessDenied';
import { SecureRoute } from './config/SecureRoute';
import { AuthContext } from './AuthContext';
import { Filter } from './Filter';
import { ErrorPage } from './components/Auth/Error/ErrorPage';

const AppContainer = () => {
  const auth = React.useContext(AuthContext);

  // Access is gated by Keycloak (see <Auth>), so the app only ever renders the
  // authenticated routes.
  const getAuthRouter = () => {
    const authRoutes = Object.keys(ROUTES).filter((key) => ROUTES[key] instanceof SecureRoute).map(key => ROUTES[key]);

    return createHashRouter(
      authRoutes.map(route => { return {
        path: route.path,
        element: (
          <Screen title={route.title}>
            <Filter>
              {route.isAllowed(auth) ? React.createElement(route.component) : <AccessDenied/>}
            </Filter>
          </Screen>
        ),
        errorElement: <ErrorPage />,
      }
    }));
  }

  return (
    <>
      <ToastContainer maxToasts={5}/>
      <RouterProvider router={getAuthRouter()}/>
    </>
  );
}

export { AppContainer }
